// src/pages/ContentEditor/constants.js
// Grade level options
export const gradeLevels = Array.from({ length: 12 }, (_, i) => ({ 
    value: i + 1, 
    label: `Grade ${i + 1}` 
  }));
  
  
// Topic categories
export const categories = [
  "Mindfulness and Well-being",
  "Nature and Environment",
  "Test Prep",
  "Career Exploration",
  "College Exploration",
  "Fantasy and Adventure",
  "Sports and Recreation",
  "History and Heritage",
  "Mystery and Thriller",
  "Science and Technology",
  "Culture and Traditions",
  "Travel and Exploration",
  "Inspirational and Motivational",
  "Business and Economics",
  "Financial Literacy",
  "Music and Entertainment",
  "Art and Creativity",
  "Food and Culinary Arts",
  "Heatlh and Human Sciences",
  "Life Skills",
  "Friendship and Community",
  "Glyph Space Explorer",
  "Futuristic"
]